import React from 'react';
/**
 * __Object base__
 *
 * An object represents an Atlassian-specific content type.
 *
 */
export default function ObjectBase(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? '' : _ref$label,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    testId = _ref.testId,
    color = _ref.color,
    Icon = _ref.icon;
  return /*#__PURE__*/React.createElement(Icon, {
    label: label,
    size: size === 'medium' ? 'medium' : 'small',
    color: color,
    testId: testId
  });
}